import React, { useReducer, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react";
import Confetti from 'react-confetti';
import ReactAudioPlayer from 'react-audio-player';
import { LogoComp } from "../elements";

import dingSound from "../../files/level.wav";

const HypeTimer = (props) => {
  const { settings = {} } = props;
  const easy = settings.difficulty === 'easy';

  const init_state = {
    active: false,
    blink: false,
    close: false,
    color: 'white',
    colorcounter: 0,
    complete1: false,
    complete2: false,
    complete3: false,
    complete4: false,
    complete5: false,
    counter: 0,
    ding: false,
    full: false,
    levelup: false,
    minutes: 0,
    percentage: 0,
    raised: -1,
    seconds: 0,
    spin: '',
    starcounter: 0
  }

  const min = useRef(new URLSearchParams(window.location.search).get('min'));
  const myInterval = useRef(0);

  const reducer = (state, action) => {
    let updatedState = { ...state };

    switch (action.type) {
      case 'RAISED_INCREASED':
        if (action.raised > 0) {
          updatedState.raised = action.raised;
        }
        if (state.raised !== -1 && (action.raised - state.raised) >= min.current) {
          updatedState.active = true;
          updatedState.close = false;
          updatedState.minutes = 5;
          updatedState.percentage = state.percentage + (settings.percentageIncrease || 20); // easy = 20, med = 35, hard = 20
          updatedState.seconds = 0;
          updatedState.spin = 'pulse';

          if (easy) {
            switch (state.counter) {
              case 0:
                updatedState.color = 'white'
                break;
              case 1:
                updatedState.color = 'bronze'
                break;
              case 2:
                updatedState.color = 'silver'
                break;
              case 3:
                updatedState.color = 'gold'
                break;
              case 4:
                updatedState.color = 'platinum'
                break;
              default:
                break;
            }
          }
          else { // difficulty = medium or hard
            if (([5, 10, 15, 20].includes(state.counter)) && state.percentage === 0) {
              updatedState.levelup = true;
              updatedState.ding = true;
            }
            if (state.starcounter === 5) {
              updatedState.complete1 = true;
              updatedState.complete2 = false;
              updatedState.complete3 = false;
              updatedState.complete4 = false;
              updatedState.complete5 = false;
              updatedState.starcounter = 1;
            }
            switch (state.counter) {
              case 5:
                updatedState.color = 'bronze';
                updatedState.counter++;
                break;
              case 10:
                updatedState.color = 'silver'
                updatedState.counter++;
                break;
              case 15:
                updatedState.color = 'gold'
                updatedState.counter++;
                break;
              case 20:
                updatedState.color = 'platinum'
                updatedState.counter++;
                break;
              default:
                break;
            }
          }
        }
        break;
      case 'TIMER_TICKED':
        if (updatedState.seconds > 0) {
          updatedState.seconds--;
          updatedState.spin = '';
        }

        if (updatedState.percentage === 0) {
          updatedState.full = false;
        }

        if (easy) {
          if (updatedState.percentage == 100) {
            updatedState.full = true;
            updatedState.counter++;
            updatedState.ding = true;
            updatedState.levelup = true;
            updatedState.percentage = 0;
          }

          if (updatedState.counter >= 1 && updatedState.counter <= 5) {
            updatedState[`complete${updatedState.counter}`] = true;
          }

          if (updatedState.seconds === 0) {
            if (updatedState.minutes === 0) {
              updatedState.close = false;
              updatedState.active = false;
              updatedState.percentage = 0;
              updatedState.complete1 = false;
              updatedState.complete2 = false;
              updatedState.complete3 = false;
              updatedState.complete4 = false;
              updatedState.complete5 = false;
            }
            else {
              updatedState.minutes--;
              updatedState.seconds = 59;
            }
          }
        }
        else { // difficulty of medium or hard
          if (updatedState.percentage >= 100) {
            updatedState.blink = true;
            updatedState.full = true;
            updatedState.counter++;
            updatedState.starcounter++;
            updatedState.percentage = 0;
          }

          if (updatedState.starcounter >= 1 && updatedState.starcounter <= 5) {
            updatedState[`complete${updatedState.starcounter}`] = true;
          }

          if (updatedState.seconds === 0) {
            if (updatedState.minutes === 0) {
              updatedState.close = false;
              updatedState.active = false;
              updatedState.percentage = 0;
            }
            else {
              updatedState.minutes--;
              updatedState.seconds = 59;
            }
          }
        }

        if (updatedState.minutes === 0 && updatedState.seconds <= 59 && updatedState.seconds > 0) {
          updatedState.close = true;
        }

        if (updatedState.minutes === 4 && updatedState.seconds <= 57) {
          updatedState.levelup = false;
          updatedState.ding = false;
        }

        break;
    }
    return updatedState;
  }

  const [state, dispatch] = useReducer(reducer, init_state);

  useEffect(() => {
    dispatch({ type: 'RAISED_INCREASED', raised: props.overlayStore.raised });
  }, [props.overlayStore.raised])

  useEffect(() => {
    if (state.active) {
      myInterval.current = setInterval(() => dispatch({ type: 'TIMER_TICKED' }), 1000);
    }
    return () => clearInterval(myInterval.current);
  }, [state.active])

  const { minutes, seconds, counter, percentage, active, spin, complete1, complete2, complete3, complete4, complete5, close, full, ding, color, levelup } = state
  const { raised } = props.overlayStore;
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const audioOnOff = urlParams.get('sound');
  const bgColor = urlParams.get('bgColor');
  const level = urlParams.get('level');
  const volume = urlParams.get('volume');
  const vol = volume / 100


  return (
    <div className="hype">
      {audioOnOff === 'on' ?
        ding === false ?
          ''
          :
          <ReactAudioPlayer
            src={dingSound}
            volume={vol}
            autoPlay
          />

        : ''}
      <div className="hype__background cf">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <div className={`star ${easy ? 'white' : color} ${complete1 ? 'active' : 'inactive'}`} />
        <div className={`star ${easy ? 'bronze' : color} ${complete2 ? 'active' : 'inactive'}`} />
        <div className={`star ${easy ? 'silver' : color} ${complete3 ? 'active' : 'inactive'}`} />
        <div className={`star ${easy ? 'gold' : color} ${complete4 ? 'active' : 'inactive'}`} />
        <div className={`star ${easy ? 'platinum' : color} ${complete5 ? 'active' : 'inactive'}`} />
      </div>
      <div className="hype__middle cf">
        <div className="left cf">
          <div className={`hype__left ${close === true ? 'close' : ''}`}>
            <p className="hype__left__countdown">
              {minutes === 0 ? '' : `${minutes}`}:{seconds < 10 ? `0${seconds}` : seconds}
            </p>
          </div>
          <div className={`hype__right ${active === true ? 'active' : ''}`}>

            {levelup === true ?
              <div className={'hype__right__lvlup ' + `${color}`}>
                <Confetti
                  width={500}
                  height={93}
                  numberOfPieces={100}
                  colors={['#8332a7', '#1874dc', '#64d0e4', '#c0da07', '#ffc32c', '#490e67', '#002856', '#1eadc1', '#75bc21', '#ffb125', '#c10f3a']}
                />
                <div className="first">L</div>
                <div className="second">E</div>
                <div className="third">V</div>
                <div className="fourth">E</div>
                <div className="fifth">L</div>

                <div className="sixth">U</div>
                <div className="seventh">P</div>

              </div>
              :
              ''
            }

            {level === 'yes' ? <div className="hype__right__lvl active">
              LVL {counter}
            </div> : ''}

            <div
              className={`
                    hype__right__meter 
                    ${bgColor}
                    ${full === true ? 'full' : ''}`
              }
              style={{
                width: `
                      ${percentage}%
                    `
              }}
            />

            <div
              className="hype__right__meter__back"
              style={{
                width: `
                      ${percentage}%
                    `
              }}
            />

          </div>
          <div className="hype__raised">{raised}</div>
        </div>
        <div className="hype__logo left">
          <LogoComp
            sjclass={spin}
            plclass="hide"
          />
        </div>
      </div>
    </div>
  );
}

export default inject("overlayStore")(observer(HypeTimer));